export const environment = {
  production: false,
  googleTagManager: {
    container: 'UA-52895040-1',
    data: 'dataLayer',
    enabled: true,
  },
};
